import { HP_HOST_URL, HP_TICKET_URL_PART, } from '../constants';
import { IHelpPopupTicket } from '../types';
import { IFeedbackSession } from '../store/types';
import { fetchHandler } from '../../../../../util/fetchHandler';

export const ticketSender = (ticket: IHelpPopupTicket, sessionId: IFeedbackSession): Promise<any> => new Promise<void>((res, rej) => {
    return fetchHandler(`${HP_HOST_URL}${HP_TICKET_URL_PART}/${sessionId}`, {
        headers: {
            'Content-type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(ticket),
    }, true).then(() => res()).catch(() => rej(new Error('Network response was not ok.')));
});
